/**
 * Loox Carousel Container Handler
 */
function waitForElement(querySelector, timeout) {
  return new Promise((resolve, reject) => {
    var timer = false;
    if (document.querySelectorAll(querySelector).length) return resolve();
    const observer = new MutationObserver(() => {
      if (document.querySelectorAll(querySelector).length) {
        observer.disconnect();
        if (timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    if (timeout)
      timer = setTimeout(() => {
        observer.disconnect();
        reject();
      }, timeout);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  waitForElement('.loox-v2-carousel-container', 10000).then(() => {
    const look = document.querySelectorAll('.loox-v2-carousel-container');
    if (look[0]) look[0].parentNode.parentNode.classList.add('loox-v2-carousel-container-1');
    if (look[1]) look[1].parentNode.parentNode.classList.add('loox-v2-carousel-container-2');
  }).catch(e => {});
});
